/**
 * Track0tic™ Brand Component
 * "Track0tic" wordmark with the "0" in red + ™ + tagline.
 * Tagline ("track verified") is rendered lowercase, smaller than the
 * wordmark, centered, and stacked directly below it.
 */
export function TrackOticBrand({
  className = "",
  size = "default",
  showTagline = false,
  tagline = "track verified",
}) {
  const sizeClasses = {
    xs: "text-sm",
    sm: "text-base",
    default: "text-lg",
    lg: "text-2xl",
    xl: "text-3xl",
    "2xl": "text-4xl",
    "3xl": "text-5xl",
    "4xl": "text-6xl",
  };

  // Tagline is intentionally MUCH smaller than the brand so the wordmark
  // dominates. Sits centered directly under the wordmark.
  const taglineSizes = {
    xs: "text-[6px]",
    sm: "text-[7px]",
    default: "text-[8px]",
    lg: "text-[9px]",
    xl: "text-[10px]",
    "2xl": "text-[11px]",
    "3xl": "text-xs",
    "4xl": "text-sm",
  };

  return (
    <span className={`inline-flex flex-col items-center leading-tight ${className}`}>
      <span className={`font-bold ${sizeClasses[size]} leading-none`}>
        Track<span className="text-red-500">0</span>tic
        <sup className="text-[0.4em] opacity-60 relative -top-[0.95em] -ml-[0.02em] align-baseline" style={{ lineHeight: 0 }}>™</sup>
      </span>
      {showTagline && (
        <span
          className={`${taglineSizes[size]} font-medium normal-case tracking-[0.12em] opacity-60 mt-1 text-center`}
        >
          {tagline}
        </span>
      )}
    </span>
  );
}

export const DEFAULT_TAGLINE = "track verified";
